import { CapoPlugin } from "/Users/michael/Development/pingzapper/site/pz-site/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];